import React from 'react'
import PropTypes from 'prop-types'

const eventHandler = (callback, event) => {
  event.stopPropagation()
  callback(event)
}

const CustomerRow = ({ customer, history, onSelectCustomer }) => (
  <div className='customers__row'
    onClick={eventHandler.bind(this, () => {
      onSelectCustomer(customer.uuid)
      history.push(`/customers/${customer.uuid}`)
    })}
  >
    <div>
      <span className="name">{customer.name}</span>
    </div>
  </div>
)

CustomerRow.defaultProps = {
  customer: {},
  onSelectCustomer: () => {}
}

CustomerRow.propTypes = {
  customer: PropTypes.object,
  onSelectCustomer: PropTypes.func
}

export default CustomerRow
